import {UI} from "../../../../../../stem-core/src/ui/UIBase";

import {BasePanelPage} from "../../BasePanelPage";
import {Messages} from "../../../../../Messages";
import {iFrameUserDataService} from "../../../../../services/IFrameUserDataService";
import {MerchantButton} from "../../../../../common/MerchantButton";
import {subscribeFlowState} from "../../../../inline-subscription/SubscribeFlowState";
import {Router} from "../../../../../../stem-core/src/ui/Router";
import {MessageElement} from "../../../../../widget/ui/MessageElement";


export class EditSubscriptionCancelPanel extends BasePanelPage {
    getDefaultOptions() {
        return {
            ...super.getDefaultOptions(),
            title: Messages.editSubscriptionCancelTitle,
        };
    }

    render() {
        const subscription = iFrameUserDataService.getActiveSubscription();
        const {styleSheet} = this;

        return [
            <MessageElement className={styleSheet.description} message={Messages.editSubscriptionCancelText1(
                subscription.getOffer().getCoverageName(), subscription.formatPrice(),
                subscription.getActiveUntil().format("MMMM DD, YYYY"))} />,
            <div className={styleSheet.description}>{Messages.editSubscriptionCancelText2}</div>,
            <MerchantButton onClick={() => subscribeFlowState.cancel()} className={styleSheet.button}>
                {Messages.editSubscriptionCancelButton}
            </MerchantButton>,
            <div className={styleSheet.center}>
                <div onClick={() => Router.back()} className={styleSheet.secondaryButton}>{Messages.noTakeMeBack}</div>
            </div>
        ]
    }
}
